import { Injectable }                 from '@angular/core';
import { ImportTypeEnum }             from '@app/modules/structure-import/models/structure-import.model';
import { ImportSetDTOImportTypeEnum } from '@openApiGenerated/import-api';
import { LoggerService }              from '@shared/services/logger.service';

@Injectable( {
	providedIn: 'root'
} )
export class StructureImportMapperService {

	constructor(
		private _logger: LoggerService
	) {}

	get import() {
		return {
			importTypeDtoToTmo: this.mapImportTypeDtoToTmo.bind( this ) as typeof this.mapImportTypeDtoToTmo,
			importTypeTmoToDto: this.mapImportTypeTmoToDto.bind( this ) as typeof this.mapImportTypeTmoToDto
		};
	}

	private mapImportTypeDtoToTmo( importTypeDTO: ImportSetDTOImportTypeEnum ): ImportTypeEnum {

		switch ( importTypeDTO ) {
			case ImportSetDTOImportTypeEnum.ORGANIZATION:
				return ImportTypeEnum.ORGANIZATION;

			case ImportSetDTOImportTypeEnum.BUSINESS_PREMISES:
				return ImportTypeEnum.BUSINESS_PREMISES;

			case ImportSetDTOImportTypeEnum.DFKA:
				return ImportTypeEnum.DFKA;

			case ImportSetDTOImportTypeEnum.ERS:
				return ImportTypeEnum.ERS;

			case ImportSetDTOImportTypeEnum.EXT_ERS:
				return ImportTypeEnum.ERS_EXTERNAL;

			case ImportSetDTOImportTypeEnum.EXT_TSS:
				return ImportTypeEnum.TSS_EXTERNAL;

			case ImportSetDTOImportTypeEnum.STRUCTURE:
				return ImportTypeEnum.STRUCTURE;

			default:
				if ( importTypeDTO ) {
					this._logger.warn( `mapImportTypeDtoToTmo has no case for DTO ${ importTypeDTO }` );
				}
				return null;
		}
	}

	private mapImportTypeTmoToDto( importType: ImportTypeEnum ): ImportSetDTOImportTypeEnum {

		switch ( importType ) {
			case ImportTypeEnum.ORGANIZATION:
				return ImportSetDTOImportTypeEnum.ORGANIZATION;

			case ImportTypeEnum.BUSINESS_PREMISES:
				return ImportSetDTOImportTypeEnum.BUSINESS_PREMISES;

			case ImportTypeEnum.ERS:
				return ImportSetDTOImportTypeEnum.ERS;

			case ImportTypeEnum.ERS_EXTERNAL:
				return ImportSetDTOImportTypeEnum.EXT_ERS;

			case ImportTypeEnum.TSS_EXTERNAL:
				return ImportSetDTOImportTypeEnum.EXT_TSS;

			case ImportTypeEnum.STRUCTURE:
				return ImportSetDTOImportTypeEnum.STRUCTURE;

			default:
				if ( importType ) {
					this._logger.warn( `mapImportTypeTmoToDto has no case for TMO ${ importType }` );
				}
				return null;
		}
	}
}
